"use client";

import React, { useMemo, useCallback } from "react";
import Slider from "react-slick"; // Assuming you're using react-slick
import { ImageWrapper, Text } from "ui-components";

interface ICorporateSolutionSliderProps {
  awardsAchievements: {
    logo: string;
    title: string;
    description: string;
  }[];
}

export default function CorporateSolutionSlider({
  awardsAchievements,
}: ICorporateSolutionSliderProps): JSX.Element {
  // Memoized customPaging function to avoid re-definition during each render
  const customPaging = useCallback(
    () => <div className="w-2.5 h-2.5 rounded-ful" />,
    []
  );

  const settings = {
    infinite: true,
    arrows: true,
    speed: 1000,
    slidesToShow: 1,
    autoplay: true,
    pauseOnHover: true,
    dots: true,
    customPaging,
    cssEase: "ease-in-out",
    fade: true,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          slidesPerRow: 1,
        },
      },
      {
        breakpoint: 768,
        settings: {
          dots: true,
          arrows: true,
          autoplay: false,
          pauseOnHover: false,
          slidesToShow: 1,
          slidesToScroll: 1,
          rows: 1,
        },
      },
      {
        breakpoint: 480,
        settings: {
          dots: true,
          arrows: true,
          autoplay: false,
          pauseOnHover: false,
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  const renderItems = useMemo(
    () =>
      awardsAchievements?.map((award, index) => (
        <div
          key={`slide-${index.toString()}`}
          className="flex flex-col sm:flex-row items-center text-center sm:text-left mx-auto gap-y-4 gap-x-6 pb-4 mt-2"
        >
          <div className="relative w-auto h-[252px] md:h-[145px] rounded">
            <ImageWrapper
              src={award.logo}
              alt={award.title}
              objectFit="contain"
              fill
              unoptimized
            />
          </div>
          <div className="flex flex-col w-full mx-auto md:float-left mt-10">
            <Text className="!text-lg !font-bold !text-center">
              {award.title}
            </Text>
            <Text variant="base" className="text-sm mt-2 text-center">
              {award.description}
            </Text>
          </div>
        </div>
      )),
    [awardsAchievements]
  );

  return (
    <div className="w-full md:w-[500px] mt-10 mx-auto">
      <Slider {...settings}>{renderItems}</Slider>
    </div>
  );
}
